import { render, staticRenderFns } from "./autoparts.vue?vue&type=template&id=54f79e5c&scoped=true"
import script from "./autoparts.vue?vue&type=script&lang=js"
export * from "./autoparts.vue?vue&type=script&lang=js"
import style0 from "./autoparts.vue?vue&type=style&index=0&id=54f79e5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f79e5c",
  null
  
)

export default component.exports